import { useEffect, useState } from 'react';

export interface FrontChannelDto {
  id: string;
  name?: string | null;
  address?: string | null;
  type?: string | null;
}

export const useListFrontChannels = () => {
  const [channels, setChannels] = useState<FrontChannelDto[] | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setIsLoading(true);
        const res = await fetch(
          `${import.meta.env.VITE_APP_DJANGO_BACKEND_HOST}/api/integrations/front/channels/`,
          { credentials: 'include' },
        );
        if (!res.ok) {
          throw new Error(`Failed to load channels (${res.status})`);
        }
        const data = (await res.json()) as FrontChannelDto[];
        if (mounted) setChannels(data);
      } catch (e) {
        if (mounted)
          setError(e instanceof Error ? e.message : 'Failed to load channels');
      } finally {
        if (mounted) setIsLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return { channels, isLoading, error };
};
